import React from 'react'
import { Image } from 'antd';
import WeddingSection from './WeddingSection';
import AnimationIn from 'components/AnimationIn';

export default function WeddingComingSection() {
    return (
        <WeddingSection>
            <div
                className='no-wedding-padding-x no-wedding-padding-y'
                style={{
                    // textAlign: 'center',
                    // position: "relative",
                    // marginTop: "20px"
                    position: "relative",
                    // height: "100vh"
                }}>
                <div style={{ position: "relative" }}>
                    <Image alt="wedding_coming" src="/img/wedding_coming.jpg" width="100%" preview={false}
                        style={{
                            height: "100vh",
                            objectFit: "cover",
                        }} />
                    <div style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        backgroundColor: "#00000000",
                        // backgroundColor: "#47451e50",
                        pointerEvents: "none",
                    }} />
                    <div
                        style={{
                            position: "absolute",
                            top: "20%",
                            left: "15%",
                            transform: "translate(-10%, -20%)",
                        }}>
                        <AnimationIn animationName="fadeRight">
                            <div
                                style={{
                                    textAlign: "center",
                                    fontFamily: "'Dancing Script', cursive",
                                    fontStyle: "italic",
                                    fontSize: "25px",
                                    color: "#fffac2",
                                    letterSpacing: "2px",
                                }}>
                                Từ Hà Nội đến Sài Gòn,
                            </div>
                        </AnimationIn>
                    </div>
                </div>

                <div
                    style={{
                        position: "absolute",
                        top: "25%",
                        left: "25%",
                        transform: "translate(-10%, -20%)",
                    }}>
                    <AnimationIn animationName="fadeLeft">
                        <div
                            style={{
                                textAlign: "center",
                                fontFamily: "'Dancing Script', cursive",
                                fontStyle: "italic",
                                fontSize: "25px",
                                color: "#fffac2",
                                letterSpacing: "2px",
                            }}>
                            chúng mình sắp cưới...!
                        </div>
                    </AnimationIn>
                </div>
            </div>
        </WeddingSection>
    )
}
